module.exports = __webpack_public_path__ + "img/Frame 1011five.7b3e60aa.png";